import { StateCreator } from 'zustand'

const isKmInputVisibleInitialState = false

export interface IsKmInputVisibleSlice {
  isKmInputVisible: boolean
  setIsKmInputVisible: (payload: boolean) => void
}

const createIsKmInputVisibleSlice: StateCreator<IsKmInputVisibleSlice> = (
  set
) => ({
  isKmInputVisible: isKmInputVisibleInitialState,
  setIsKmInputVisible: (payload) => {
    set(() => ({
      isKmInputVisible: payload,
    }))
  },
})

export default createIsKmInputVisibleSlice
